import { render, staticRenderFns } from "./bulkSectionUpdate.vue?vue&type=template&id=45b79a65"
import script from "./bulkSectionUpdate.vue?vue&type=script&lang=js"
export * from "./bulkSectionUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports